<!--
 * @Autor: Baowang
 * @Date: 2024-11-18 18:00:16
 * @pageName: 主页面底部
 * @LastEditTime: 2024-11-21 17:55:29
-->
<template>
  <div class="publicBottom animate__animated animate__fadeInUp" :style="{ backgroundColor: bgColor }">
    <!-- 图标 -->
    <div class="publicBottom_image">
      <el-image class="image_one" :src="require('../../assets/logo.png')" fit="fill" lazy></el-image>
    </div>
    <!-- 联系我们 -->
    <div class="publicBottom_lianxi">
      <div class="lianxi_title">联系我们</div>
      <div class="lianxi_count">
        <div class="count_one">电话：{{ config.plat_mobile }}</div>
        <div class="count_one">
          地址：{{ config.plat_address }}
        </div>
        <div class="count_one">邮箱：{{ config.plat_email }}</div>
      </div>
    </div>
    <!-- 条款信息 -->
    <div class="publicBottom_tiaokuan">
      <div class="tiaokuan_title">条款信息</div>
      <div class="tiaokuan_count">
        <div class="count_ones">©{{ config.copyright }}</div>
        <div class="count_ones">
          <span class="mouseGestures" @click="goAgment(1)">隐私政策</span><span class="mouseGestures" @click="goAgment(0)">｜服务条款</span><span>｜公司证照</span>
        </div>
        <div class="count_ones">
          <img src="../../assets/beian.png" alt="" />
          {{ config.web_filing }}
        </div>
      </div>
    </div>
    <!-- 小程序 -->
    <div class="publicBottom_xcx">
      <div class="publicBottom_xcx_title">进入小程序</div>
      <div class="xcx_image">
        <img :src="config.wechat_qr" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    bgColor: {
      type: String,
      default: "#FFFFFF",
    },
  },
  data() {
    return {
      config: {}
    };
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$api({
        url: "/api/index/get_config",
        method: "POST",
      }).then((res) => {
        this.config = res.data
      })
    },
    // 跳转协议
    goAgment(id) {
      this.$store.commit("updateAgemnt", id);
      this.$router.push({ name: "agemnt", query: { ids: id } });
    },
  },
};
</script>
<style lang="less" scoped>
.publicBottom {
  width: 100%;
  height: 240px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .publicBottom_image {
    .image_one {
      width: 100px;
      height: 100px;
    }
  }

  //   联系我们
  .publicBottom_lianxi {
    .lianxi_title {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 16px;
      color: #000000;
    }

    .lianxi_count {
      margin-top: 35px;

      .count_one {
        font-family: PingFang SC, PingFang SC;
        font-weight: normal;
        font-size: 12px;
        color: #000000;
        margin-bottom: 10px;
      }
    }
  }

  //   条款信息
  .publicBottom_tiaokuan {
    .tiaokuan_title {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 16px;
      color: #000000;
    }

    .tiaokuan_count {
      margin-top: 35px;

      .count_ones {
        font-family: PingFang SC, PingFang SC;
        font-weight: normal;
        font-size: 12px;
        color: #000000;
        margin-bottom: 10px;

        img {
          width: 16px;
          height: 16px;
          display: inline-block;
          vertical-align: top;
        }
      }
    }
  }

  //   进入小程序
  .publicBottom_xcx {
    .publicBottom_xcx_title {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 16px;
      color: #000000;
    }

    .xcx_image {
      width: 120px;
      height: 120px;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      margin-top: 15px;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
